import { BusinessStatus, Role } from '../../mappers/business/toBusinessModel';
import { OwnersDataUI } from '../posts/types';
import type { BusinessMemberStatus, ImportFormat } from '../../types';

type BusinessLinks = Partial<{
    site: string;
    shortSite: string;
    siteDisplay: string;
    telegram: string;
}>;

export enum OfferAgreement {
    UNSET = 'unset',
    SIGNED = 'signed',
}

export interface BusinessStatItemUI {
    value: number;
    display: string;
    diffValue: number;
    diffDisplay: string;
}

export interface BusinessStatsUI {
    coverage: {
        total: BusinessStatItemUI;
        subscribers: BusinessStatItemUI;
        notsubscribers: BusinessStatItemUI;
        boosted?: BusinessStatItemUI;
        organic?: BusinessStatItemUI;
    };
    involved: {
        total: BusinessStatItemUI;
        subscribers: BusinessStatItemUI;
        notsubscribers: BusinessStatItemUI;
        boosted?: BusinessStatItemUI;
        organic?: BusinessStatItemUI;
    };
    shows: {
        total: BusinessStatItemUI;
        subscribers: BusinessStatItemUI;
        notsubscribers: BusinessStatItemUI;
        boosted?: BusinessStatItemUI;
        organic?: BusinessStatItemUI;
    };
    showsInGrid: {
        total: BusinessStatItemUI;
        subscribers: BusinessStatItemUI;
        notsubscribers: BusinessStatItemUI;
        boosted?: BusinessStatItemUI;
        organic?: BusinessStatItemUI;
    };
    subscribers: {
        total: BusinessStatItemUI;
        subscribed: BusinessStatItemUI;
        unsubscribed: BusinessStatItemUI;
    };
    interactions: {
        total: BusinessStatItemUI;
        clicks: BusinessStatItemUI;
        likes: BusinessStatItemUI;
        shares: BusinessStatItemUI;
        saves: BusinessStatItemUI;
    };
}

export enum BusinessType {
    BUSINESS = 'business',
    BLOGGER = 'blogger',
    SERVICE = 'service',
}

export enum BusinessDescriptionStatus {
    accepted = 'accepted',
    declined = 'declined',
    moderation = 'moderation',
    limited = 'limited',
}

export interface BusinessReviewsInfo {
    rating?: number;
    reviews?: number;
    url?: string;
}

export interface BusinessUI {
    __type?: 'lite' | 'standard';
    id: string;
    publicId: string;
    url: string;
    siteUrl?: string;
    shortSite?: string;
    statisticUrl: string;
    shareUrl: string;
    avatarUrl?: string;
    coverUrl?: string;
    displayName: string;
    subscribed: boolean;
    subscribers?: number;
    posts?: number;
    description?: string;
    descriptionStatus?: BusinessDescriptionStatus;
    role: Role;
    editLink: string;
    links: BusinessLinks;
    status?: BusinessStatus;
    statusDisplay?: string;
    catalogTitle: string;
    catalogUrl?: string;
    type?: BusinessType;
    allowedToBoosts?: boolean;
    reviewsInfo?: BusinessReviewsInfo;
    isService?: boolean;
}

export interface BusinessPersistenceUI {
    id?: string;
    publicId?: string;
    displayName?: string;
    description?: string;
    descriptionStatus?: BusinessDescriptionStatus;
    avatarUrl?: string;
    coverUrl?: string;
    links?: BusinessLinks;
    createdAt?: string;
    hideInFeed?: boolean;
    offerAgreement?: OfferAgreement;
    instagram?: {
        url?: string;
        importFormat?: ImportFormat;
    };
    telegram?: {
        url?: string;
        importFormat?: ImportFormat;
    };
    ads?: {
        importFormat?: ImportFormat;
    };
    categories?: Record<number, CategoryUI>;
    useProductsAutoImport?: boolean;
    useProductsDisableAutoParser?: boolean;
    allowedToBoosts?: boolean;
    geotargeting?: number[];
}

export interface BusinessMemberUI {
    login: string;
    avatarUrl: string;
    memberId: string;
    displayName: string;
    isCurrentUser: boolean;
    status: BusinessMemberStatus;
}

export interface RegistrationUI {
    instagramUrl: string;
    email: string;
    offerAgreement: boolean;
    sendAdMails: boolean;
    telegramUrl: string;
    otherUrl?: string;
    youtubeUrl?: string;
    vkUrl?: string;
    needCpaRegistration?: boolean;
    geotargeting?: number[];
}

export interface BusinessRegistrationUI extends RegistrationUI {
    domain: string;
    displayName: string;
}

export interface BloggerRegistrationUI extends RegistrationUI {
    bloggersRegisterUrl?: string;
}

export interface CategoryUI {
    id: number;
    name: string;
    checked?: boolean;
    indeterminate?: boolean;
    children?: CategoryUI[];
}

export interface CatalogUI {
    title: string;
    ownersData?: OwnersDataUI;
    business?: BusinessUI;
}
